import React from 'react';
import ApplicationListConmponent from '../../component/application/application-list-container';

const render = () => <ApplicationListConmponent />;

export default render;
